import React from "react";
import ThreadItemMenu from "./threadItemMenu";

const ThreadItemMenuContainer = ({
  refMenuButton,
  open,
  thread,
  onClose,
  onDeleteThread,
}: React.ComponentProps<typeof ThreadItemMenu>) => {
  return (
    open && (
      <ThreadItemMenu
        refMenuButton={refMenuButton}
        open={open}
        thread={thread}
        onClose={onClose}
        onDeleteThread={onDeleteThread}
      />
    )
  );
};

export default ThreadItemMenuContainer;
